module.exports = __webpack_public_path__ + "img/django.73bd3aa5.jpg";